'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrape = exports.connectToScrapper = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.default = scrapper;

var _socket = require('socket.io-client');

var _socket2 = _interopRequireDefault(_socket);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _actionTypes = require('../actionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SCRAPE_ENDPOINT = '/scrape';

var CONNECT = 'connect';
var DISCONNECTED = 'disconnected';
var SCRAPPER_CHUNCK_RECEIVED = 'SCRAPPER_CHUNCK_RECEIVED';
var SOCKETS_ACTIONS = ['connect', 'disconnected', 'SCRAPPER_CHUNCK_RECEIVED'];

var initialState = {
  isConnected: false,
  isLoading: false,
  error: false,
  urls: {}
};

function scrapper() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case CONNECT:
      return (0, _extends5.default)({}, state, { isConnected: true });
    case DISCONNECTED:
      return (0, _extends5.default)({}, state, { isConnected: false });
    case SCRAPPER_CHUNCK_RECEIVED:
      {
        return (0, _extends5.default)({}, state, {
          isLoading: !action.data.isFinish,
          urls: (0, _extends5.default)({}, state.urls, (0, _defineProperty3.default)({}, action.data.url, (0, _extends5.default)({}, state.urls[action.data.url], action.data.chunk)))
        });
      }
    case _actionTypes.scrapperActions.SCRAPE.STARTED:
      return (0, _extends5.default)({}, state, {
        isLoading: true,
        error: false
      });
    case _actionTypes.scrapperActions.SCRAPE.COMPLETED:
      return (0, _extends5.default)({}, state, {
        isLoading: false,
        urls: (0, _extends5.default)({}, state.urls, (0, _defineProperty3.default)({}, action.result.url, action.result.info))
      });
    case _actionTypes.scrapperActions.SCRAPE.FAILED:
      return (0, _extends5.default)({}, state, {
        isLoading: false,
        error: true
      });
    default:
      return state;
  }
}

var io = void 0;

var connectToScrapper = exports.connectToScrapper = function connectToScrapper() {
  return function (dispatch, getState) {
    if (!io || !getState().scrapper.isConnected) {
      io = (0, _socket2.default)('', { path: '/ws' });
      SOCKETS_ACTIONS.forEach(function (action) {
        io.on(action, function (data) {
          return dispatch({ type: action, data: data });
        });
      });
    }
  };
};

var scrape = exports.scrape = function scrape(url) {
  return {
    types: _actionTypes.scrapperActions.SCRAPE.TYPES,
    promise: function promise(client) {
      return client.post(SCRAPE_ENDPOINT, { data: { url: url } });
    }
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/scrapper.js
 ** module id = 461
 ** module chunks = 0
 **/